import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { Link, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { YearSelect, MonthSelect } from "../../../../helpers/ui/YearSelect";

import EmployeeTableComponent from "./Components/EmployeeTableComponent";

import classnames from "classnames";

class CreateView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      detailUuid: null,
      tooltipOpen: false,
      activeRef: React.createRef(),
      loading: false,
    };
  }

  toggleTooltip = () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  };

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log(response);
            this.setState({
              dataForm: response,
              detailUuid: response.position_mapping_period_uuid,
              loading: false,
            });

            // this.createBloc.fetchEmployee({ uuid: queryParams.get("uuid") });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    // this.createBloc.employeeChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.INITIAL:
    //       this.setState({
    //         loadingTable: false,
    //       });
    //       break;
    //     case apiResponse.LOADING:
    //       this.setState({
    //         loadingTable: true,
    //       });
    //       break;
    //     case apiResponse.COMPLETED:
    //       const response = result.data.response;
    //       this.setState({
    //         totalRow: response.total,
    //         rows: response.result,
    //         loadingTable: false,
    //       });
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    // this.createBloc.fetchEmployee({ uuid: queryParams.get("uuid") });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.detailChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Card className="">
            <CardBody>
              <CardTitle>Edit Persediaan Pegawai</CardTitle>
              <CardSubtitle className="mb-3">
                Setiap isian yang bertanda (
                <span className="text-danger">*</span>) adalah wajib diisi.
              </CardSubtitle>
              <hr />
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
              >
                <AvField
                  name="position_mapping_uuid"
                  type="hidden"
                  id="position_mapping_uuid"
                  value={this.state.dataForm.position_mapping_uuid}
                />

                <Row className="mb-3">
                  <label htmlFor="no_sk" className="col-md-2 col-form-label">
                    Periode
                  </label>
                  <Col md="2">
                    <MonthSelect
                      name="position_period_month"
                      errorMessage="Pilih Periode"
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Periode"
                      isDisabled={true}
                    />
                  </Col>
                  <Col md="2">
                    <YearSelect
                      name="position_period_year"
                      errorMessage="Pilih Tahun"
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Tahun"
                      isDisabled={true}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="position_mapping_position_name"
                    className="col-md-2 col-form-label"
                  >
                    Jabatan
                  </label>
                  <Col md="7">
                    <AvField
                      placeholder="Nama Jabatan"
                      name="position_mapping_position_name"
                      id="position_mapping_position_name"
                      type="text"
                      className="form-control"
                      value={
                        this.state.dataForm?.position_mapping_position_name
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="position_mapping_work_unit_name"
                    className="col-md-2 col-form-label"
                  >
                    Unit Kerja
                  </label>
                  <Col md="7">
                    <AvField
                      placeholder="Unit Kerja"
                      name="position_mapping_work_unit_name"
                      id="position_mapping_work_unit_name"
                      type="text"
                      className="form-control"
                      value={
                        this.state.dataForm?.position_mapping_work_unit_name
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="type_name"
                    className="col-md-2 col-form-label"
                  >
                    Jenis Jabatan
                  </label>
                  <Col md="3">
                    <AvField
                      placeholder="Jenis Jabatan"
                      readonly="readonly"
                      name="type_name"
                      id="type_name"
                      type="text"
                      className="form-control"
                      value={this.state.dataForm?.type_name}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="position_mapping_position_grade"
                    className="col-md-2 col-form-label"
                  >
                    Kelas Jabatan
                  </label>
                  <Col md="3">
                    <AvField
                      readonly="readonly"
                      placeholder="Kelas Jabatan"
                      name="position_mapping_position_grade"
                      id="position_mapping_position_grade"
                      type="text"
                      className="form-control"
                      value={
                        this.state.dataForm?.position_mapping_position_grade
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="position_mapping_bp"
                    className="col-md-2 col-form-label"
                  >
                    Persediaan Pegawai <b>(BP)</b>
                  </label>
                  <Col md="3">
                    <AvField
                      readonly="readonly"
                      placeholder="Persediaan Pegawai"
                      name="position_mapping_bp"
                      id="position_mapping_bp"
                      type="text"
                      className="form-control"
                      value={this.state.dataForm?.position_mapping_bp}
                    />
                  </Col>
                  {/* {this.state.dataForm?.position_mapping_bp > 0 ? (
                    <Col md="3">
                      <Button
                        color="info"
                        id="list-employee"
                        type="button"
                        onClick={() =>
                          this.setState((prevState) => ({
                            showTable: !prevState.showTable,
                          }))
                        }
                      >
                        <i className="uil-users-alt"></i>
                      </Button>

                      <Tooltip
                        placement="top"
                        isOpen={this.state.tooltipOpen}
                        target="list-employee"
                        toggle={this.toggleTooltip}
                      >
                        Lihat list pegawai
                      </Tooltip>
                    </Col>
                  ) : null} */}
                </Row>

                <Row className="mb-3">
                  <label
                    htmlFor="position_mapping_kp"
                    className="col-md-2 col-form-label"
                  >
                    Kebutuhan Pegawai<b>(KP)</b>{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <Col md="3">
                    <AvField
                      placeholder="Kebutuhan Pegawai (KP)"
                      name="position_mapping_kp"
                      id="position_mapping_kp"
                      type="number"
                      className="form-control"
                      value={this.state.dataForm?.position_mapping_kp}
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <label className="col-md-2 col-form-label">Lowongan</label>
                  <Col md="3">
                    <AvField
                      name="selisih"
                      readonly="readonly"
                      placeholder="Lowongan"
                      type="text"
                      className="form-control"
                      value={
                        this.state.dataForm?.position_mapping_bp -
                        this.state.dataForm?.position_mapping_kp
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="3"></Col>
                  <Col md="9">
                    <Link
                      to={
                        "/kepegawaian/strukturorganisasi.html?detail&uuid=" +
                        this.state.dataForm.position_mapping_period_uuid
                      }
                    >
                      <Button color="danger">
                        <i className="uil-arrow-left"></i> Kembali
                      </Button>
                    </Link>{" "}
                    <Button color="success" type="submit">
                      <i className="uil-arrow-up-right"></i> Simpan Data
                    </Button>
                  </Col>
                </Row>
              </AvForm>

              {this.state.dataForm?.position_mapping_bp > 0 ? (
                <>
                  <hr />
                  <CardTitle>Daftar Pegawai</CardTitle>
                  <EmployeeTableComponent />
                </>
              ) : null}
            </CardBody>
          </Card>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mencari detail..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              "/kepegawaian/strukturorganisasi.html?detail&uuid=" +
              this.state.detailUuid
            }

            // +
            //   this.state.dataForm.position_mapping_period_uuid
          />
        ) : null}
      </Fragment>
    );
  }
}

export default CreateView;
